import React from 'react';
import { Lock, Skull, FileSignature } from 'lucide-react';
export function ProtocolIncludes() {
  const items = [{
    icon: <Lock className="w-6 h-6" data-id="element-103" />,
    title: 'La Trampa de la Disculpa',
    description: 'Por qué tu cerebro busca desesperadamente validación del verdugo y el interruptor exacto para detener este ciclo destructivo.'
  }, {
    icon: <Skull className="w-6 h-6" data-id="element-104" />,
    title: 'La Morgue Emocional',
    description: "El proceso paso a paso para dejar de visitar el 'cadáver' de situaciones, relaciones y promesas que ya murieron."
  }, {
    icon: <FileSignature className="w-6 h-6" data-id="element-105" />,
    title: 'El Contrato de Rescisión',
    description: 'El documento simbólico y psicológico para declarar tu deuda emocional en Cero absoluto. Eres libre.'
  }];
  return <section className="py-24 px-4 bg-zinc-950" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-zinc-100 mb-16" data-id="element-108">
          Lo que incluye el Protocolo
        </h2>

        <div className="space-y-6" data-id="element-109">
          {items.map((item, index) => <div key={index} className="flex flex-col md:flex-row gap-6 items-start bg-zinc-900/40 p-8 border border-zinc-800/50 hover:bg-zinc-900/80 transition-colors" data-id="element-110">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-900/20 rounded-full flex items-center justify-center text-amber-500 border border-amber-500/20" data-id="element-111">
                {item.icon}
              </div>
              <div data-id="element-112">
                <h3 className="text-xl text-zinc-100 font-serif mb-2" data-id="element-113">
                  {item.title}
                </h3>
                <p className="text-zinc-400 leading-relaxed" data-id="element-114">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}